import React, { useState } from 'react'
import NumberFormat from 'components/NumberFormat';
import Button from 'components/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import PageLoader from 'components/PageLoader';
import './ReserveForm.scss'
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        background: 'none',
        boxShadow: 'none',
        zIndex: '999',
        backgroundColor: "rgba(255, 255, 255)"
    }
};
const PUBLIC_REQUEST = 1
const PRIVATE_REQUEST = 2

const ReserveForm = (props) => {
    let label = ''
    let event_details = ''
    const hasPackages = props.packages.length > 0;
    const [modalCancelRules, setModalCancelRules] = useState(false)

    // Label
    if (props.isVoucherSelected) {
        label = ''
    } else if (!props.isForRequest) {
        label = (
            <p className="label label-green">
                <span className="icon-checkmark-circle" />
                {props.vacancies} vagas disponíveis!
                <Tooltip title="Este o número de pessoas que ainda podem participar desse evento">
                    <span className="tooltip-helper">?</span>
                </Tooltip>
            </p>
        )
    }

    // Event detail
    if (props.request) {
        if (Number(props.request.type) === PRIVATE_REQUEST) {
            event_details = (
                <div className="event-detail">
                    <p>Evento: <span className="event-type">Fechado</span></p>
                    {!!props.request.name && <p>Agendado por: <span className="event-owner">{props.request.name}</span></p>}
                    {!!props.request.phone && <p>Contato: <span className="event-contact">{props.request.phone}</span></p>}
                </div>
            )
        }
    }

    return (
        <div>
            {event_details}
            {hasPackages ?
                <>
                    {((props.isDateSelected && props.isHourSelected) || props.isVoucherSelected) // Data selecionada
                        && !(props.isMobile && !props.isModal)
                        ?
                        <div>
                            {label}

                            <div className="Grid Gird-cell">
                                <h3 className="side-checkout-title">Escolha seu pacote</h3>
                            </div>

                            <div className="packages-container">
                                <PageLoader loading={props.loadingPackages}>
                                    {props.packages.sort((a, b) => a.price > b.price).map(p =>
                                        <div key={p.pk_package} className="package-info-row">
                                            <div className="row-payment-info">
                                                <div className='package-name'>{p.name}</div>
                                                <div className='package-price'> R$ {(!!p.priceWithDiscount) ?
                                                    <NumberFormat value={p.priceWithDiscount} /> :
                                                    <NumberFormat value={p.price} />}
                                                    <Tooltip title={p.description}>
                                                        <span className="tooltip-helper reverse">i</span>
                                                    </Tooltip>
                                                </div>
                                                {!!p.max &&
                                                    <div className="package-max">
                                                        {p.max - p.reserves.length} disponível
                                                    </div>
                                                }
                                            </div>
                                            <div className="row-payment-info">
                                                <div className="package-quantity">
                                                    <div onClick={() => props.handleRemovePackage(p.pkPackage)}>
                                                        <div className={`minus ${p.quantity === 0 || !props.canRemovePackage ? "disabled" : ""}`}> - </div>
                                                    </div>
                                                    <div className="number"> {p.quantity} </div>
                                                    <div onClick={() => props.handleAddPackage(p.pkPackage)}>
                                                        <div className={`plus ${!props.canAddPackage(p.pkPackage) && "disabled"}`}> + </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </PageLoader>
                            </div>
                        </div>
                        :
                        ''
                    }
                </>
                :
                <div className="Grid Gird-cell">
                    <h5 className="side-checkout-title">Nenhum tipo de ingresso cadastrado. Favor, entre em contato conosco para continuar.</h5>
                </div>
            }
            <div className={`Grid Grid--center contract contract-mobile ${props.buttonAlign ? 'align-' + props.buttonAlign : ''}`}>
                <Button loading={!!props.loadingContinue} disabled={!((props.isDateSelected && props.isHourSelected && props.packagesCount) || (props.isVoucherSelected && props.packagesCount))} type="green" size="full" onClick={props.isModal ? () => props.onModalContinue() : () => props.onContinue()}>
                    <div>CONTINUAR</div>
                </Button>
            </div>
            {
                !props.noLinks &&
                <>
                    <div className="Grid-row text-pink" style={{ marginTop: 10, alignItems: 'center' }}>
                        <i style={{ marginRight: 10, fontSize: 28 }} className="fa fa-info-circle text-pink" />
                        <div className="Grid-cell">
                            <small>Alguma informação contida aqui você não está de acordo? <a className="text-pink" rel="noopener noreferrer" target="_blank" href="https://api.whatsapp.com/send?phone=5541996881577">Informe um problema</a></small>
                        </div>
                    </div>
                    <div className="Grid-row">
                        <div className="Grid-cell">
                            <Link onClick={() => props.cancel_rules ? setModalCancelRules(true) : window.open('/cancelamento', '_blank')}>
                                <p className="side-checkout-link left">
                                    <span className="icon-book" /> Cancelamento Fácil
                                </p>
                            </Link>
                        </div>
                        <div className="Grid-cell">
                            <Link onClick={() => props.privacyTerm ? window.open(props.privacyTerm, '_blank') : window.open('/seguranca', '_blank')}>
                                <p className="side-checkout-link right">
                                    <span className="icon-lock" /> Segurança de dados
                                </p>
                            </Link>
                        </div>
                    </div>
                </>
            }
            {
                props.cancel_rules &&
                <Modal
                    isOpen={modalCancelRules}
                    onRequestClose={() => setModalCancelRules(false)}
                    style={customStyles}
                >
                    <div className="box-modal">
                        <div className="Grid Grid--gutter Grid-column">
                            <div className="Grid-cell">
                                <div className="close-modal">
                                    <p className="float-right" onClick={() => setModalCancelRules(false)}>
                                        Fechar X
                                    </p>
                                </div>
                            </div>
                            <div className="Grid-cell">
                                <div className="modal-content content-cancel-rules">
                                    <h4>Regras de Cancelamento</h4>
                                    <div className='text'>
                                        {props.cancel_rules}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
        </div >
    )
}

export default ReserveForm
